export default {
  LOGIN: '/login',
  MAIN: '/',
  ASSETS_HOME: '/assets',
  HOME: '/home',
  WELCOME: '/welcome',

  USER_SECURITY: '/security',
  USER_SECURITY_MOBILE: '/security/mobile',
  USER_SECURITY_MOBILE_BIND: '/security/mobile/bind',
  USER_SECURITY_MOBILE_UPDATE: '/security/mobile/update',
  USER_SECURITY_EMAIL: '/security/email',
  USER_SECURITY_EMAIL_BIND: '/security/email/bind',
  USER_SECURITY_EMAIL_UPDATE: '/security/email/update',
  USER_SECURITY_GA: '/security/ga',
  USER_SECURITY_GA_BIND: '/security/ga/bind',
  USER_SECURITY_PIN: '/security/pin',
  SECURITY_2FA: '/security/2fa',
  FORGOT_PW: '/security/forgotpw',
  CHANGE_PW: '/security/changepw',
  ACCOUNT_DELETE: '/security/delete',
  
  KYC_MAIN: '/identity',
  KYC_SUMSUB: '/identity/verify',
  KYC_PRE_FORM: '/identity/preform',
  KYC_AML: '/identity/aml',

  HELP_CENTER: '/helpcenter',
  ABOUT_US: '/aboutus',

  LIVE_DETECT: '/live_detect',

  CARD_HOME: '/card',
  BUY_CARD: '/card/buy',
  CARD_APPLY: '/card/apply',
  CARD_APPLY_LIST: '/card/apply/list',
  CARD_APPLY_ORDER: '/card/apply/order',
  CARD_APPLY_ORDER_DETAIL: '/card/apply/order/detail',

  CARD_BILL_LIST: '/card/bill_list',
  CARD_BILL_DETAIL: '/card/bill_detail',
  CARD_BILL_DOWNLOAD: '/card/bill_download',

  CARD_TRANS_LIST: '/card/trans/list2',
  CARD_TRANS_DETAIL: '/card/trans/detail',
  ASSETS_TRANS_LIST: '/assets/trans/list',
  ASSETS_TRANS_DETAIL: '/assets/trans/detail',
  WITHDRAW: "/assets/withdraw",
  WITHDRAW_LIST: '/assets/withdraw_list',
  WITHDRAW_DETAIL: '/assets/withdraw_detail',
  DEBT_DETAILS: '/assets/debt/details',
  DEBT_PAYMENT_DETAIL: '/assets/debt/payment/detail',
  DEBT_UNPAYMENT_DETAIL: '/assets/debt/unpayment/detail',

  MINE_HOME: '/mine',
  BIND_MOBILE: '/bind_mobile',
  BIND_EMAIL: '/bind_email',

  CARD_DEPOSIT: '/card_deposit',
  CARD_MANAGEMENT: '/card_management',
  CARD_MODIFY: '/card_management/modify',
  CARD_WITHDRAW: '/card_withdraw',

  CARD_DELETE: '/card_delete',

  // guide.
  GUIDE_BIND_EMAIL: '/guide_email',
  GUIDE_BIND_MOBILE: '/guide_mobile',
  GUIDE_KYC_PRE: '/kyc_pre',
  GUIDE_KYC: '/guide_kyc',
  GUIDE_BILL_ADDRESS: '/bill_address',
  GUIDE_DEPOSIT: '/guide_deposit',
  GUIDE_APPLY_CARD: "/guide_apply_card",

  VARIETY_SELECT: '/user/deposit/variety',

  DEPOSIT_VARIETY_SELECT: '/user/deposit/variety',
  DEPOSIT_LIST: '/deposit/list',
  WITHFRAW_VARIETY_SELECT: '/user/withdraw/variety',
  // user
  USER_BILL_ADDRESS: '/user/bill_address',

  USER_DEPOSIT: '/user/deposit',
  USER_WITHDRAW: '/user/withdraw',
  USER_WITHDRAW_DETAIL: '/user/withdraw/detail',
  USER_WITHDRAW_SUCCESS: '/user/withdraw/success',
  USER_ADDRESS_LIST: '/user/addresses',
  USER_ADDRESS_ADD: '/user/addresses/add',
  USER_WITHDRAW_SEND_CODE: '/user/withdraw/sendcode',
  SUCCESS: '/success',

  USER_DEPOSIT_LIST: '/user/deposit/list',

  MESSAGE_LIST: '/message',

  ASSET_LOG_LIST: '/asset_log_list',
  ASSET_LOG_DETAIL: '/asset_log_detail',

  CARD_PAYMENT_CURRENCY_SETTINGS: '/card/payment_currency_settings',

  CARD_REISSUE: '/card/reissue',

};
